import { Readout } from '../components/Readout';
import { StatusLed } from '../components/StatusLed';

/**
 * Top status bar — scope-style equipment header.
 *
 * Slots:
 *   [logo + title]   [SR | BAUD | MODE]   [STATUS LED + label]
 */
export class Header {
  readonly el: HTMLElement;
  private statusLed: StatusLed;
  private statusText: HTMLSpanElement;
  private menuBtn!: HTMLButtonElement;
  readonly readouts: { sampleRate: Readout; baud: Readout; mode: Readout };

  constructor() {
    this.el = document.createElement('header');
    this.el.className = 'app-header';

    const brand = document.createElement('div');
    brand.className = 'app-header__brand';
    brand.innerHTML = `
      <span class="app-header__mark">${markSvg()}</span>
      <div>
        <div class="app-header__title">Sonic DTX</div>
        <div class="app-header__sub">Acoustic 4-FSK</div>
      </div>
    `;

    this.readouts = {
      sampleRate: new Readout('Sample Rate', '—', 'Hz'),
      baud: new Readout('Baud', '—', 'sym/s'),
      mode: new Readout('Mode', 'IDLE'),
    };
    this.readouts.mode.setTone('default');

    const readouts = document.createElement('div');
    readouts.className = 'app-header__readouts';
    readouts.appendChild(this.readouts.sampleRate.el);
    readouts.appendChild(this.readouts.baud.el);
    readouts.appendChild(this.readouts.mode.el);

    this.statusLed = new StatusLed('on');
    this.statusText = document.createElement('span');
    this.statusText.textContent = 'READY';

    const status = document.createElement('div');
    status.className = 'app-header__status';
    status.appendChild(this.statusLed.el);
    status.appendChild(this.statusText);

    this.menuBtn = document.createElement('button');
    this.menuBtn.type = 'button';
    this.menuBtn.className = 'app-header__menu';
    this.menuBtn.setAttribute('aria-label', 'Setup');
    this.menuBtn.innerHTML = `
      <span></span><span></span><span></span>
    `;
    const menuWrap = document.createElement('div');
    menuWrap.className = 'app-header__menu-wrap';
    menuWrap.appendChild(this.menuBtn);

    this.el.appendChild(brand);
    this.el.appendChild(readouts);
    this.el.appendChild(status);
    this.el.appendChild(menuWrap);
  }

  onMenu(fn: () => void): void {
    this.menuBtn.addEventListener('click', fn);
  }

  setStatus(label: string, tone: 'on' | 'warn' | 'error' | 'off', pulse = false): void {
    this.statusText.textContent = label.toUpperCase();
    this.statusLed.set(tone, pulse);
  }
}

function markSvg(): string {
  // Mini-oscilloscope-mark: cyan trace on dark square with hairline frame.
  return `<svg viewBox="0 0 28 28" width="28" height="28" aria-hidden="true">
  <rect x="0.5" y="0.5" width="27" height="27" fill="var(--surface-2)" stroke="var(--border-strong)"/>
  <line x1="0.5" y1="14" x2="27.5" y2="14" stroke="var(--graticule-axis)" stroke-width="0.5"/>
  <line x1="14" y1="0.5" x2="14" y2="27.5" stroke="var(--graticule-axis)" stroke-width="0.5"/>
  <path d="M2 14 Q 6 4 10 14 T 18 14 T 26 14"
        fill="none" stroke="var(--accent)" stroke-width="1.4" stroke-linecap="round"
        style="filter: drop-shadow(0 0 1.5px var(--accent))"/>
</svg>`;
}
